import {  ChangeDetectorRef, Component,EventEmitter,Input,OnInit,Output,ViewChild, } from '@angular/core';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar'; 
import { Subscription } from 'rxjs/internal/Subscription';
import { filter, map } from 'rxjs/operators';
import { MenuItem, Pagination } from 'src/app/app.models';
import { AppService } from 'src/app/app.service';
import { AppSettings, Settings } from 'src/app/app.settings';
import { VehiculeserviceService } from "src/app/services/vehiculeservice.service";

@Component({
  selector: "app-menu",
  templateUrl: "./menu2.component.html",
  styleUrls: ["./menu2.component.scss"],
})
export class Menu2Component implements OnInit{
  @ViewChild("sidenav") sidenav: any;
  public sidenavOpen: boolean = false;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  public psConfig: PerfectScrollbarConfigInterface = {
    wheelPropagation: true,
  };
  public menuItems: Array<any> = [];
  public categories: any[] = [];
  public viewType: string = "grid";
  public viewCol: number = 25;
  public count: number = 12;
  public myInputMessage: any;
  public sort: string = "";
  public selectedCategoryId: number = 0;
  public pagination: Pagination = new Pagination(1, this.count, null, 2, 0, 0);
  public message: string | null = "";
  public watcher: Subscription;
  public settings: Settings;

  initData: Array<any> = [];

  constructor(
    public appSettings: AppSettings,
    public appService: AppService,
    public mediaObserver: MediaObserver,
    public car: VehiculeserviceService,
  ) {
    this.settings = this.appSettings.settings;
    this.watcher = mediaObserver
      .asObservable()
      .pipe(
        filter((changes: MediaChange[]) => changes.length > 0),
        map((changes: MediaChange[]) => changes[0])
      )
      .subscribe((change: MediaChange) => {
        if (change.mqAlias == "xs") {
          this.sidenavOpen = false;
          this.viewCol = 100;
        } else if (change.mqAlias == "sm") {
          this.sidenavOpen = false;
          this.viewCol = 50;
        } else if (change.mqAlias == "md") {
          this.sidenavOpen = false;
          this.viewCol = 33.3;
        } else {
          this.sidenavOpen = false;
          this.viewCol = 25;
        }
      });
  }

  ngOnInit(): void {
    
    this.getCategories();
    this.getMenuItems();
  }

  ngOnDestroy() {
    this.watcher.unsubscribe();
  }

  public getCategories() {
    this.appService.getCategories().subscribe((categories) => {
      this.categories = categories;
      this.appService.Data.categories = categories;
    });
  }
  public selectCategory(id: number) {
    this.selectedCategoryId = id;
    this.menuItems.length = 0;
      this.resetPagination();
    if (this.selectedCategoryId == 0) {
      this.getMenuItems();
    } else if ( this.selectedCategoryId == 1) {
      this.selectedCategoryId = 0;
      this.allVehicleSuv();
      
    }else if ( this.selectedCategoryId == 2 ) {
      this.selectedCategoryId = 0;
      this.allVehicleBerline();
    }else if ( this.selectedCategoryId == 3 ) {
      this.selectedCategoryId = 0;
      this.allVehicleUtilitaire();
    }else {
      this.selectedCategoryId = 0;
      this.allVehicleMonospace();
    }
    //this.sidenav.close();
  }
  public onChangeCategory(event: any) {
    this.selectCategory(event.value);
  }

  //get all vehicles
  public getMenuItems() {
    this.car.getallCardispo().subscribe((data: any) => {
      this.initData =data;
      let cars:Array<{[key:string]:any}>;
      cars =data.filter((elt:any)=>elt.priority==1);
      if (cars.length <= 0) {
        this.menuItems.length = 0;
        this.pagination = new Pagination(1, this.count, null, 2, 0, 0);
        this.message = "No Results Found";
      } else {
        this.getDataCars(cars);
        this.message = null;
      }
    });
  }
//get all suv or 4x4
public allVehicleSuv() {
  this.car.allVehicleSuv().subscribe((data: any) => {
    this.initData = data;
    console.log(data);
    if (data.length <= 0) {
      this.menuItems.length = 0;
      this.pagination = new Pagination(1, this.count, null, 2, 0, 0);
      this.message = "No Results Found";
    } else {
      this.getDataCars(data);
      this.message = null;
    }
  });
}
//get all berline or citadine
public allVehicleBerline(){
  this.car.allVehicleBerline().subscribe((data: any) => {
    this.initData = data;
    console.log(data);
    if (data.length <= 0) {
      this.menuItems.length = 0;
      this.pagination = new Pagination(1, this.count, null, 2, 0, 0);
      this.message = "No Results Found";
    } else {
      this.getDataCars(data);
      this.message = null;
    }
  });
}
//get all monospace or familliale
public allVehicleMonospace(){
  this.car.allVehicleMonospace().subscribe((data: any) => {
    this.initData = data;
    console.log(data);
    if (data.length <= 0) {
      this.menuItems.length = 0;
      this.pagination = new Pagination(1, this.count, null, 2, 0, 0);
      this.message = "No Results Found";
    } else {
      this.getDataCars(data);
      this.message = null;
    }
  });
}

public allVehicleUtilitaire(){
  this.car.allVehicleUtilitaire().subscribe((data: any) => {
    this.initData = data;
    console.log(data);
    if (data.length <= 0) {
      this.menuItems.length = 0;
      this.pagination = new Pagination(1, this.count, null, 2, 0, 0);
      this.message = "No Results Found";
    } else {
      this.getDataCars(data);
      this.message = null;
    }
  });
}
  public resetPagination() {
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.pagination = new Pagination(
      1,
      this.count,
      null,
      null,
      this.pagination.total,
      this.pagination.totalPages
    );
  }

  public filterData(data: any) {
    return this.appService.filterData(
      data,
      this.selectedCategoryId,
      this.sort,
      this.pagination.page,
      this.pagination.perPage
    );
  }
  // public filterData(data){
  //   return this.appService.filterData(data, this.searchFields, this.sort, this.pagination.page, this.pagination.perPage);
  // }

  public changeCount(count: number) {
    this.count = count;

    console.log(count);
    this.menuItems.length = 0;
    this.resetPagination();
    this.getMenuItems();
  }

  public changeSearch(text: any) {
    console.log(text);

    if(!text) {
      console.log("je suis la");

      this.getDataCars(this.initData);

    } else {

      let currentCars = this.menuItems.filter(function(car: any) {
                
        return car['mark_lib'].trim().toLowerCase() == text.trim().toLowerCase() || 
                car['mod_lib'].trim().toLowerCase() == text.trim().toLowerCase() ||
                Number(car['vehicle_price_location']) == Number(text);
  
      });
          
      if(currentCars.length > 0 ){ 
  
        this.getDataCars(currentCars);
  
      }

    }
    
  
  }

  getDataCars(data: any) {
    this.menuItems =[];

    let result = this.filterData(data)
  
    this.menuItems = result.data;
        
    this.pagination = result.pagination;
  
    this.myInputMessage = data;

  }


  public changeViewType(obj: any) {
    this.viewType = obj.viewType;
    this.viewCol = obj.viewCol;
  }

  public onPageChange(e: any) {
    this.pagination.page = e.pageIndex + 1;
    this.getMenuItems();
    window.scrollTo(0, 0);
  }
} 